import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=c825a18a&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=c825a18a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c825a18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c825a18a')) {
      api.createRecord('c825a18a', component.options)
    } else {
      api.reload('c825a18a', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=c825a18a&scoped=true", function () {
      api.rerender('c825a18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Grid/Card.vue"
export default component.exports